<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>{{ modalTitle }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <p class="text-danger text-center" v-if="hasError">{{ errorMessage }}</p>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input type="image" container-class="mb-3" placeholder="Sélectionner une image"
                     default="DEFAULT_PICTURE" v-model="picture" :state="pictureState">
              Veuillez charger une image
            </c-input>
          </d-col>
          <d-col class="ml-2">
            <c-input container-class="mb-3" label="Nom de la catégorie" placeholder="Ex: My-CoolPay" v-model="name"
                     :state="nameState">
              Veuillez saisir un nom
            </c-input>
            <c-input container-class="mb-3" label="Slug" placeholder="Ex: M_CP" v-model="slug" :state="slugState">
              Veuillez saisir un slug
            </c-input>
            <c-input type="textarea" container-class="mb-3" label="Description" placeholder="Entrez une description..."
                     v-model="description">
              Veuillez saisir un nom
            </c-input>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4">
        <d-input-group class="justify-content-center">
          <d-button class="inline-btn" @click="modalVisible = true">
            <i class="fa fa-plus mr-1"></i> Ajouter une catégorie
          </d-button>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="data" :fields="fields" :actions="actions" :per-page="25">
          <p class="text-center" slot="empty">Aucune catégorie trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, asset, Toast} from "@/helpers"

export default {
  title: "Catégories de cagnottes",
  data() {
    return {
      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'picture', label: 'Image'},
        {key: 'name', label: 'Nom de la catégorie', sortable: true},
        {key: 'slug', label: 'Slug', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {type: 'white', icon: 'fa fa-edit', title: "Modifier la catégorie", handler: this.onItemSelect},
        {type: 'outline-danger', icon: 'fa fa-times', title: "Supprimer la catégorie", handler: this.onItemRemove},
      ],

      modalVisible: false,

      selectedItem: null,

      picture: null,
      name: '',
      slug: '',
      description: '',

      submitted: false,
      fetchingFormSubmit: false,
    }
  },
  computed: {
    itemSelected() {
      return !!this.selectedItem
    },
    modalTitle() {
      return this.itemSelected ? "Edition d'une catégorie de cagnotte" : "Ajout d'une catégorie de cagnotte"
    },
    pictureState() {
      return true
      // return !this.submitted || this.logo
    },
    nameState() {
      return !this.submitted || this.name.trim().length > 0
    },
    slugState() {
      return !this.submitted || this.slug.trim().length > 0
    },
  },
  created() {
    this.fetchingData = true
    Api.get('/raising_category/list')
      .then(res => this.data = res.data.raising_categories.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        picture: asset(item.image),
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.picture = item.picture
      this.name = item.name
      this.slug = item.slug
      this.description = item.description
      this.modalVisible = true
    },
    clearFields() {
      this.picture = null
      this.name = ''
      this.slug = ''
      this.description = ''
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.error = null
      this.clearFields()
    },
    isFormValid() {
      return this.pictureState && this.nameState && this.slugState
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      const route = this.itemSelected ? '/raising_category/update' : '/raising_category/create'
      const extraData = this.itemSelected ? {raising_category_id: this.selectedItem.id} : {}

      this.fetchingFormSubmit = true
      Api.postFormData(route, {
        image: this.picture,
        name: this.name,
        slug: this.slug,
        description: this.description,
        ...extraData
      })
        .then(res => {
          const raising_category = this.mapItem(res.data.raising_category)
          const operation = this.itemSelected ? "mise à jour" : "créée"

          if (this.itemSelected)
            this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, raising_category)
          else
            this.data.push(raising_category)

          this.onModalClose()

          Toast.success(`La catégorie "${raising_category.name}" a été ${operation} avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onItemRemove(item) {
      const ans = prompt(`Veuillez saisir SUPPRIMER pour supprimer la catégorie "${item.name}".`)
      if (ans !== 'SUPPRIMER') return

      Toast.loading("Suppression la catégorie...")
      Api.postFormData('/raising_category/delete', {
        raising_category_id: item.id
      })
        .then(res => {
          this.data = this.data.filter(_item => _item.id !== item.id)
          Toast.success(`La catégorie "${item.name}" a été supprimée avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    }
  }
}
</script>

<style scoped>

</style>
